import { employmentBondLabels } from '@hue/contracts';
import type { CommissionClosingView } from '../../lib/api.js';

/// Marca UTF-8, para o Excel abrir os acentos certos.
const BOM = String.fromCharCode(0xfeff);
const cents = (value: number) => (value / 100).toFixed(2).replace('.', ',');

function cell(value: string): string {
  // Neutraliza fórmula em quem abre no Excel e aspas no meio do texto.
  const safe = /^[=+\-@]/u.test(value) ? `'${value}` : value;
  return `"${safe.replaceAll('"', '""')}"`;
}

/// A exportação leva tudo, sem escolha de itens (ADR 0082, decisão 22).
export function commissionClosingCsv(closing: CommissionClosingView): string {
  const header = [
    'Mês',
    'Profissional',
    'Vínculo',
    'Pagamento',
    'Conta do plano',
    'Comissão',
    'Vales',
    'Líquido',
    'Saldo de vales',
    'Ainda não apurado',
    'Pago',
    'Falta pagar',
  ];
  const lines = closing.lines.map((line) => [
    closing.month,
    line.resourceDisplayName,
    line.employmentBond ? employmentBondLabels[line.employmentBond] : '',
    line.employmentBond === 'CLT' ? (line.offPayroll ? 'Fora da folha' : 'Na folha') : '',
    line.accountCode ?? '',
    cents(line.commissionCents),
    cents(line.advancesCents),
    cents(line.netCents),
    cents(line.carryCents),
    cents(line.pendingCommissionCents),
    cents(line.paidCents),
    cents(line.outstandingCents),
  ]);
  const rows = [header, ...lines].map((row) => row.map(cell).join(';')).join('\r\n');
  return `${BOM}${rows}\r\n`;
}
